module.exports = __webpack_public_path__ + "static/media/boxlogo.4c818ed8.png";